import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { buttonStyles } from '../../../Components/docsAdministrative/JsObjectStyles';

function DocumentAdministratifs() {
    const navigate = useNavigate();
    const {pathname}=useLocation();
    const { i18n } = useTranslation();
    return (
        <>
            <div className='frame5Profile'> {i18n.t('Demandes à valider')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{i18n.t('Documents administratifs')}</span> </div>

            <div className='HomeFrame'>
                <h4 className='titlesociete'>{i18n.t('Demandes à valider')}</h4>
                <div className='frame8TableMissionBDCAdmin'>
                    <Button
                        className='frame29CvTheque'
                        onClick={() =>
                        {
                            navigate('/admin/documentAdministratifs');
                            //setClientTable(true);
                        }}
                        style={
                            (!pathname.includes('Expert') && !pathname.includes('Esn')) ?
                                {...buttonStyles(),...{
                                    background: '#E7EAF9',
                                    color: '#214DCE',
                                    borderRadius:'60px',
                                }}:
                                {...buttonStyles(),...{
                                    color: '#475063',
                                    borderRadius:'60px',
                                }}
                        }
                    >
                        {i18n.t('Client')}
                    </Button>
                    <Button
                        className='frame31CvTheque'
                        onClick={() =>
                        {
                            navigate('/admin/documentAdministratifs/Expert');
                            //setClientTable(false);
                        }}
                        style={
                            pathname.includes('Expert')  ?
                                {...buttonStyles(),...{
                                    background: '#E7EAF9',
                                    color: '#214DCE',
                                    borderRadius:'60px',
                                }}:
                                {...buttonStyles(),...{
                                    color: '#475063',
                                    borderRadius:'60px',
                                }}
                        }
                    >
                        {i18n.t('Expert')}
                    </Button>
                    <Button
                        className='frame31CvTheque'
                        onClick={() =>
                        {
                            navigate('/admin/documentAdministratifs/Esn');
                            //setClientTable(false);
                        }}
                        //style={
                        //    clientTable == false  ?
                        //        selectedFrameCvTheque:
                        //        notSelectedFrameCvTheque
                        //}
                        style={
                            pathname.includes('Esn') ?
                                {...buttonStyles(),...{
                                    background: '#E7EAF9',
                                    color: '#214DCE',
                                    borderRadius:'60px',
                                }}:
                                {...buttonStyles(),...{
                                    color: '#475063',
                                    borderRadius:'60px',
                                }}
                        }
                    >
                        {i18n.t('Esn')}
                    </Button>
                </div>
                <Outlet/>
            </div>
        </>
    );
}

export default DocumentAdministratifs;
